import config from "../config";

const base_url = config.base_url;
export const getRegistrationRedirect = (redirect_id) => {
  return fetch(base_url + "newuser/redirect", {
    method: "POST",
    mode: "cors",
    headers: {
      Accept: "application/json, text/plain, */*",
      "Content-type": "application/x-www-form-urlencoded",
      credentials: "include",
    },
    credentials: "include",
    body: `redirect_id=${redirect_id}`,
  });
};
export const getLoginRedirect = (redirect_id) => {
  return fetch(base_url + "login/redirect", {
    method: "POST",
    mode: "cors",
    headers: {
      Accept: "application/json, text/plain, */*",
      "Content-type": "application/x-www-form-urlencoded",
      credentials: "include",
    },
    credentials: "include",
    body: `redirect_id=${redirect_id}`,
  });
};
